<template>
  <b-container fluid>
      <b-row>
        <b-col lg="12" sm="12">
          <iq-card>
            <template>
                <b-row>
                  <b-col lg="12" sm="12">
                  <b-row>
                        <b-col xs="12" sm="12" md="12" class="text-right mb-2">
                            <b-button @click="pdfExport()" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="5" sm="5">
                            <span class="text-dark">{{ $t('educational_management.fiscal_year') }} : {{ getFisName(course.fiscal_year_id) }}</span>
                        </b-col>
                        <b-col lg="7" sm="7">
                            <span class="text-dark" v-if="localeLang === 'en'">{{ $t('globalTrans.organization') }} : {{ course.organization }}</span>
                            <span class="text-dark" v-else>{{ $t('globalTrans.organization') }} : {{ course.organization_bn }}</span>
                        </b-col>
                        <b-col lg="5" sm="5">
                            <span class="text-dark" v-if="localeLang === 'en'">{{ $t('educational_management.institute_name') }} : {{ course.institute_name }}</span>
                            <span class="text-dark" v-else>{{ $t('educational_management.institute_name') }} : {{ course.institute_name_bn }}</span>
                        </b-col>
                        <b-col lg="7" sm="7">
                            <span class="text-dark" v-if="localeLang === 'en'">{{ $t('educational_management.class') }} : {{ course.class_name }}</span>
                            <span class="text-dark" v-else>{{ $t('educational_management.class') }} : {{ course.class_name_bn }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col lg="12" sm="12">
                        <div>
                          <b-table-simple striped bordered small>
                              <b-tr class="bg-primary">
                                <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                                <b-th>{{ $t('educational_management.course') }}</b-th>
                                <b-th>{{ $t('educational_management.description') }}</b-th>
                                <b-th>{{ $t('educational_management.course_teacher') }}</b-th>
                                <b-th>{{ $t('educational_management.document') }}</b-th>
                              </b-tr>
                              <b-tr v-for="(item, index) in course.details" :key="index">
                                <b-td>
                                  {{ $n(index + 1) }}
                                </b-td>
                                <b-td>
                                  {{ getCoursename(item.course_id) }}
                                </b-td>
                                <b-td>
                                  {{ getCourseDetails(item.course_id) }}
                                </b-td>
                                <b-td>
                                  {{ getInstructorname(item.instructor_id) }}
                                </b-td>
                                <b-td>
                                  <div style="float: right; width: 90px;" v-if="item.documents !== ''">
                                    <a :href="url + 'download-attachment?file=uploads/course_documentoriginal/' + item.documents" title="Candidate Image Download">Attachment Download <i class="ri-download-cloud-fill"></i></a>
                                  </div>
                                </b-td>
                              </b-tr>
                          </b-table-simple>
                        </div>
                      </b-col>
                    </b-row>
                    <div class="row">
                      <div class="col-sm-3"></div>
                      <div class="col text-right">
                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-3')">{{ $t('globalTrans.close') }}</b-button>
                      </div>
                    </div>
                  </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-container>
</template>
<script>
import ExportPdf from './export-pdf_details.js'
import { childServiceBaseUrl } from '@/config/api_config'
export default {
  props: ['id'],
  created () {
    if (this.id) {
        const tmp = this.getCourseInfoData()
        this.course = tmp
    }
  },
  data () {
    return {
        course: {
            fiscal_year_id: '',
            org_id: '',
            office_type_id: '',
            office_id: '',
            class_id: '',
            details: []
        },
        url: childServiceBaseUrl
    }
  },
  computed: {
    localeLang () {
      return this.$i18n.locale
    }
  },
  methods: {
    getCourseInfoData () {
        const tmpData = this.$store.state.list.find(item => item.id === this.id)
        return JSON.parse(JSON.stringify(tmpData))
    },
    getFisName (fisId) {
      const fisYear = this.$store.state.commonObj.fiscalYearList.find(item => item.value === fisId)
        if (this.$i18n.locale === 'bn') {
            return fisYear.text_bn
        } else {
            return fisYear.text_en
        }
    },
    getCoursename (courseId) {
        const course = this.$store.state.ChildService.commonObj.courseList.find(courseName => courseName.value === courseId)
        if (this.$i18n.locale === 'bn') {
            return course.text_bn
        } else {
            return course.text_en
        }
    },
    getInstructorname (instrictorId) {
        const course = this.$store.state.ChildService.commonObj.instructorList.find(courseName => courseName.value === instrictorId)
        if (this.$i18n.locale === 'bn') {
            return course.text_bn
        } else {
            return course.text_en
        }
    },
    getCourseDetails (courseId) {
        const course = this.$store.state.ChildService.commonObj.courseList.find(courseName => courseName.value === courseId)
        if (this.$i18n.locale === 'bn') {
            return course.description_bn
        } else {
            return course.description
        }
    },
     pdfExport () {
      const reportTitle = this.$t('educational_management.course_details')
      ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.course, this)
    }
  }
}
</script>
